import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "18b8c6b0-58de-4083-bc14-521cbfbd0e5e",
    content: "1 kHz sine tone @ 40 dB SPL",
    options: { image: `${config.ASSETS_URL}/02/09/task/task-5-item-1.svg` },
  },
  {
    id: "d664c9a2-26cb-42d0-ae6b-c4d1bcdac7f2",
    content: "1 kHz sine tone @ 60 dB SPL",
    options: { image: `${config.ASSETS_URL}/02/09/task/task-5-item-2.svg` },
  },
  {
    id: "7192080d-1576-48dc-99bf-9a9a4ba903bc",
    content: "Broadband white noise @ 40 dB SPL",
    options: { image: `${config.ASSETS_URL}/02/09/task/task-5-item-3.svg` },
  },
  {
    id: "5ab316a8-a254-4808-ab89-795ec88e0f1e",
    content: "4 kHz sine tone @ 40 dB SPL",
    options: { image: `${config.ASSETS_URL}/02/09/task/task-5-item-4.svg` },
  },
];

export const task: Task = {
  id: "42c4f4b4-245f-45ff-8bbb-c7024c3ce230",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d664c9a2-26cb-42d0-ae6b-c4d1bcdac7f2"],
};
